import React from 'react';
import Modal from '../../../../../components/Modal';

const ModalEliminarProforma = props => (
  <Modal title='Confirmar' idModal='eliminar-proforma' isOpen closeModal={props.closeModal} modalSize='modal-dialog'>
    <p className='h6 text-center'>¿Está seguro que deseas eliminar la proforma {props.proforma}?</p>
    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.closeModal}>Volver</button>
      <button className='btn btn-primary pull-right' onClick={()=>{props.desasignar()}}>Eliminar</button>
    </div>
  </Modal>
);

export default ModalEliminarProforma;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/EliminarProforma/index.js